import * as React from 'react'
import { FunctionComponent } from 'react'
import PropTypes from 'prop-types'
import { Field, Form } from 'react-final-form'
import CardActions from '@material-ui/core/CardActions'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import CircularProgress from '@material-ui/core/CircularProgress'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogContent from '@material-ui/core/DialogContent'
import { useTranslate, useNotify, useSafeSetState } from 'ra-core'
import { useHistory } from 'react-router-dom'
import useStyles from '../styles'

interface Props {
  redirectTo?: string
}

interface FormData {
  code: string | undefined
  password: string | undefined
  plain_password: string | undefined
}

const Input = ({
  meta: { touched, error }, // eslint-disable-line react/prop-types
  input: inputProps, // eslint-disable-line react/prop-types
  ...props
}: any) => {
  return <TextField error={!!(touched && error)} helperText={touched && error} {...inputProps} {...props} fullWidth />
}

const LoginForm: FunctionComponent<Props> = (props: any) => {
  const [loading, setLoading] = useSafeSetState(false)
  const history = useHistory()
  const translate = useTranslate()
  const notify = useNotify()
  const classes = useStyles(props)

  const validate = (values: FormData) => {
    const errors: FormData = {
      code: undefined,
      password: undefined,
      plain_password: undefined,
    }

    if (!values.code) {
      errors.code = translate('ra.validation.required')
    }
    if (!values.password) {
      errors.password = translate('ra.validation.required')
    }
    if (!values.plain_password) {
      errors.plain_password = translate('ra.validation.required')
    }

    if (values.plain_password && values.plain_password !== values.password) {
      errors.plain_password = translate('login.errors.samePass')
    }
    return errors
  }

  const submit = (values: any) => {
    const { code, plain_password } = values
    setLoading(true)

    const request = new Request(process.env.REACT_APP_API_PATH + '/forgot', {
      method: 'PATCH',
      body: JSON.stringify({ code, plain_password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    })
    return fetch(request)
      .then(response => {
        setLoading(false)
        if (response.status === 400) {
          return response.json()
        }
        notify('login.passChangeSuccess', 'info')
      })
      .then(object => {
        if (object && object.message) notify(object.message, 'warning')
      })
      .catch(error => {
        setLoading(false)
        notify(
          typeof error === 'string'
            ? error
            : typeof error === 'undefined' || !error.message
            ? 'ra.auth.sign_in_error'
            : error.message,
          'warning'
        )
      })
  }

  return (
    <>
      <DialogContent>
        <DialogContentText>{translate('login.seeMail')}</DialogContentText>
      </DialogContent>
      <Form
        onSubmit={submit}
        validate={validate}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} noValidate>
            <div className={classes.form}>
              <div className={classes.input}>
                <Field
                  id='code'
                  name='code'
                  component={Input}
                  label={translate('login.code')}
                  type='text'
                  disabled={loading}
                />
              </div>
              <div className={classes.input}>
                <Field
                  id='password'
                  name='password'
                  component={Input}
                  label={translate('login.newpassword')}
                  type='password'
                  disabled={loading}
                  autoComplete='current-password'
                />
              </div>
              <div className={classes.input}>
                <Field
                  id='plain_password'
                  name='plain_password'
                  component={Input}
                  label={translate('login.repeatpassword')}
                  type='password'
                  disabled={loading}
                  autoComplete='current-password'
                />
              </div>
            </div>
            <CardActions>
              <Button variant='contained' type='submit' color='primary' disabled={loading} className={classes.button}>
                {loading && <CircularProgress className={classes.icon} size={18} thickness={2} />}
                {translate('ra.auth.sign_in')}
              </Button>
            </CardActions>
            <CardActions>
              <Button
                variant='contained'
                type='button'
                onClick={() => history.push('/login')}
                color='secondary'
                disabled={loading}
                className={classes.button}
              >
                {loading && <CircularProgress className={classes.icon} size={18} thickness={2} />}
                {translate('login.gotologin')}
              </Button>
            </CardActions>
          </form>
        )}
      />
    </>
  )
}

LoginForm.propTypes = {
  redirectTo: PropTypes.string,
}

export default LoginForm
